import { useEffect } from 'react'
import { MPMLayout } from 'components/layout'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useTranslation } from 'react-i18next'
import { usePageView } from 'utils/analytics'

type UnauthorizedProps = {
    message?: string
    additionalMessage?: string
    actionMessage?: string
    title?: string
}

export const Unauthorized = ({
    message,
    additionalMessage,
    actionMessage,
    title,
}: UnauthorizedProps) => {
    const { t } = useTranslation()
    const { unauthorized } = TRANSLATION_KEYS
    const { trackPageView } = usePageView('unauthorized')
    const unauthorizedMessage = message ? message : t(unauthorized.message)
    const unauthorizedTitle =
        title !== undefined ? title : t(unauthorized.title)

    useEffect(() => {
        trackPageView()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // Empty array - only log once on mount

    return (
        <MPMLayout heading={`${unauthorizedTitle}`} breadcrumbsEnabled={false}>
            <p className="hc8-mt-3x">{unauthorizedMessage}</p>
            <br />
            <p>{additionalMessage}</p>
            <br />
            <p>{actionMessage}</p>
        </MPMLayout>
    )
}
